module.exports = (__webpack_require__(0))(201);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/body/CollectionView.js from dll-reference girder_lib
// module id = 25
// module chunks = 0